var entries = document.querySelectorAll( '.entry-expand' ).forEach( function( element, index ) {
    var img = element.getElementsByClassName( 'entry-image' )[0];
    var modal = element.getElementsByClassName( 'modal' )[0];
    var modalBody = element.getElementsByClassName( 'modal-body' )[0];
    var overlay = element.getElementsByClassName( 'modal-overlay' )[0];

    img.onclick = function() {
        modal.classList.add( 'show' );
        overlay.style.display = 'block';
    };

    overlay.onclick = function() {
        modal.classList.remove( 'show' );
        overlay.style.display = 'none';
    };
});
